import React from "react";
import { IconLock, IconReplace } from "@tabler/icons-react";
import type { SrFaceDecision } from "./sr-face-check-types";

type Props = {
    busy: boolean;
    canDecide: boolean;
    onDecide: (decision: SrFaceDecision) => void;
};

const SrFaceMatchActions = ({ busy, canDecide, onDecide }: Props) => (
    <div className="sticky bottom-0 space-y-2 border-t bg-white pt-4">
        <p className="text-xs text-gray-500">
            Select a matched voter above, then choose one action for their photos.
        </p>
        <div className="flex flex-wrap gap-2">
            <button
                type="button"
                disabled={busy || !canDecide}
                onClick={() => onDecide("replace")}
                className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-lg bg-blue-600 px-3 py-2.5 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
            >
                <IconReplace size={16} />
                Replace & save
            </button>
            <button
                type="button"
                disabled={busy || !canDecide}
                onClick={() => onDecide("keep")}
                className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
            >
                <IconLock size={16} />
                Keep existing & save
            </button>
        </div>
    </div>
);

export default SrFaceMatchActions;
